import {TitleLayout} from "~/apps/core/ui/TitleLayout";
import {AutoVisitForm, FormValues} from "~/apps/packages/auto-visits/components/AutoVisitForm/AutoVisitForm";
import {useHistory, useParams} from "react-router-dom";
import {useAutoVisit, useCurrentCarrierId, useUpdateAutoVisit} from "~/apps/packages/auto-visits/hooks";
import React, {useEffect} from "react";
import {canEditAutoVisit} from "~/apps/packages/auto-visits/utils";
import {LoadingResult} from "~/apps/core/ui/LoadingResult";
import {useErrorHandler} from "~/components/ErrorHandling";
import {useUserAuthenticated} from "~/auth/hooks";
import moment from "moment";


export const EditPage = () => {
    const handleError = useErrorHandler();
    const history = useHistory();
    const {id} = useParams<{ id: string }>();
    const userAuthenticated = useUserAuthenticated();
    const {data, loading: autoVisitLoading} = useAutoVisit(id);
    const [update, {success: saved, error: saveError}] = useUpdateAutoVisit(id);
    const [carrierId] = useCurrentCarrierId();
    const loading = autoVisitLoading || !carrierId;

    useEffect(() => {
        if (saveError) {
            handleError(saveError)
        }
    }, [saveError]);

    useEffect(() => {
        if (data && !canEditAutoVisit(data)) {
            history.goBack();
        }
    }, [data]);

    useEffect(() => {
        if (saved) {
            history.goBack();
        }
    }, [saved]);

    const handleSubmit = (values: FormValues) => {
        return update({
            Date: moment(values.Date).format("YYYY-MM-DD"),
            TimeSlotID: values.TimeSlot.ID,
            VehicleID: values.Vehicle.ID,
            CarrierID: carrierId,
            DriverID: values.Driver.ID,
            CheckPointID: values.CheckPoint.ID,
            Services: values.ServiceList.map(item => ({
                ID: item.ServiceID,
                CargoID: item.CargoID,
                Quantity: 1,
            })),
            Cargos: values.CargoList.map(item => ({
                ID: item.CargoID,
                StorageID: item.StorageID,
                Quantity: item.Quantity,
                Description: "",
                Address: {}
            }))
        });
    }

    return (
        <TitleLayout title="Редактирование" disableGutters={true}>
            <LoadingResult loading={loading}/>

            {!loading && (
                <AutoVisitForm
                    key={String(userAuthenticated)} // reset form after login
                    variant="edit"
                    onSubmit={handleSubmit}
                    carrierId={carrierId}
                    autoVisitId={id}
                    defaultValue={{
                        Date: moment(data.Date, "YYYY-MM-DD").toDate(),
                        CargoList: data.CargoList,
                        ServiceList: data.ServiceList,
                        Driver: data.Driver,
                        TimeSlot: data.TimeSlot,
                        Vehicle: data.Vehicle,
                        CheckPoint: data.CheckPoint,
                    }}
                />
            )}
        </TitleLayout>
    )
}